import { Box, IconButton, ListItem, Stack, Typography } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";
import { Tooltip } from "@mui/material";
import { AddCommunicationButton } from "../AddCommunicationButton";
import RoleIcon from "../RoleIcon";
import React from "react";
import EditCompaniesCommunication from "../EditCompaniesCommunication";
import {
  ContactPersonRolesEnum,
  ContactPersons,
} from "../../../../store/services/communicationService";

interface ContactListItemProps {
  contactPerson: ContactPersons;
  customerNo: number;
  addGroupEdit?: boolean;
}

const ContactListItem = ({
  customerNo,
  contactPerson,
  addGroupEdit,
}: ContactListItemProps) => {
  const [editContactPerson, setEditContactPerson] =
    React.useState<ContactPersons>();

  return (
    <ListItem
      sx={{
        bgcolor: (theme) => theme.palette.grey[200],
        borderLeft: (theme) => `3px solid ${theme.palette.primary.main}`,
        paddingLeft: "2px",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" width="100%">
        <Stack direction="row" alignItems="center" sx={{ flexShrink: 0 }}>
          <AddCommunicationButton
            customerNo={customerNo}
            contactPersonNo={contactPerson.ContactPersonId ?? undefined}
          />
          <BusinessIcon color="primary" fontSize="small" />
          {contactPerson.IsResponsible && (
            <Tooltip title="Ansvarig kontaktperson">
              <StarIcon fontSize="small" color="primary" />
            </Tooltip>
          )}
        </Stack>
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0, // Important for text wrapping
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ flexGrow: 1 }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  minWidth: "50px",
                }}
                noWrap={false}
              >
                {contactPerson.Firstname} {contactPerson.Lastname}
              </Typography>
              <IconButton
                size="small"
                sx={{ ml: 1, p: 0 }}
                onClick={() => setEditContactPerson(contactPerson)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Stack>
            {contactPerson.Roles?.length > 0 && (
              <Stack
                direction="row"
                spacing={0.5}
                sx={{
                  flexShrink: 0,
                  flexWrap: "wrap",
                }}
              >
                {contactPerson.Roles.map((role: ContactPersonRolesEnum) => (
                  <RoleIcon key={role} role={role} />
                ))}
              </Stack>
            )}
          </Stack>
        </Box>
      </Stack>
      {editContactPerson && (
        <EditCompaniesCommunication
          customerNo={customerNo}
          handleClose={() => setEditContactPerson(undefined)}
          person={editContactPerson}
        />
      )}
    </ListItem>
  );
};

export default ContactListItem;
